/**
 * ProBadge Component
 * 
 * Reusable component for displaying Pro feature badges throughout the application.
 * Ensures consistent styling and appearance across all pro features.
 * 
 * @package TopBuddy
 */

const ProBadge = () => {
	return (
		<span className="topbuddy-pro-badge">
			PRO
		</span>
	);
};

export default ProBadge;
